import SignaturePad from "signature_pad";
import Inputmask from 'inputmask';
import { luscinia } from "./luscinia";
import moment from "moment";
import { getFormObject } from "./modal/modal";
import MultiSelectInput from "./Bootgrid/multi-select-input";

luscinia.initFormElements = async function (filter, form) {

    var initFormElementPromiseList: JQuery.jqXHR[] = [];

    luscinia.initSummernote(filter, luscinia.config.culture);

    // Init image upload (preview)
    $(filter).find("." + luscinia.css.imageUpload).on("change", function () {
        // Create file reader, get first available file
        var fr = new FileReader();
        var fileElement = $(this);
        if ((fileElement[0] as any).files.length > 0) {
            // Reset image
            (fileElement.prev("img")[0] as any).src = "";
            fr.readAsDataURL((fileElement[0] as any).files[0]);
            // On load set image source to display image
            fr.onload = function (e) {
                (fileElement.prev("img")[0] as any).src = (e.target as any).result;
            };
        }
    });

    // Init file upload (link)
    $(filter).find("." + luscinia.css.fileUpload).on("change", function () {
        var fileElement = $(this);
        if ((fileElement[0] as any).files.length > 0) {
            // Reset link value
            fileElement.parent().find("a").remove();
        }
    });

    // Init Date / DateTime picker
    ($(filter).find(".datetime") as any).each(function (index: number, element: HTMLElement) {
        const inputEl = $(element).find("input");
        let dateValue = inputEl.val().toString();
        var myDatePicker = ($(element) as any).datetimepicker({
            locale: luscinia.config.culture,
            date: getDateTimeLocalizedValue(dateValue),
            showTodayButton: inputEl.data("show-today-button") !== undefined,
            toolbarPlacement: 'top'
        });

        myDatePicker.on("dp.change", function (e) {
            if (e.date !== e.oldDate) {
                $(this).find("input").trigger("change");
            }
        });

        myDatePicker.on("dp.show", async () => {
            const todayEl = $(element).find(".bootstrap-datetimepicker-widget a[data-action='today'] > span");
            todayEl.removeClass("glyphicon glyphicon-screenshot");

            todayEl.text(await luscinia.translate("today"));
        });
    });

    // Init Year-only picker
    ($(filter).find(".year") as any).each(function (index: number, element: HTMLElement) {
        const inputEl = $(element).find("input[data-date-year-only]");
        const hiddenInputId = inputEl.data("date-fulldate-input") as string;
        const hiddenInput = $("#" + hiddenInputId);

        const fullDateValue = hiddenInput.val()?.toString() ?? "";
        const yearValue = inputEl.val()?.toString() ?? "";

        let initialDate: Date | null = null;
        if (yearValue) {
            const year = parseInt(yearValue, 10);
            if (!isNaN(year)) {
                const full = moment(fullDateValue);
                initialDate = full.isValid() ? full.year(year).toDate() : new Date(year, 0, 1);
            }
        }

        ($(element) as any).datetimepicker({
            locale: luscinia.config.culture,
            date: initialDate,
            format: 'YYYY',
            viewMode: 'years'
        });

        $(element).on("dp.change", function (e: any) {
            if (!e || !e.date) return;
            if (e.oldDate && e.date.isSame(e.oldDate)) return;
            const newYear: number = e.date.year();
            const currentFull = moment(hiddenInput.val()?.toString() ?? "");
            const newFull = currentFull.isValid()
                ? currentFull.year(newYear)
                : moment(new Date(newYear, 0, 1));
            hiddenInput.val(newFull.toISOString());
            hiddenInput.trigger("change");
        });

        // When the hidden input is updated externally (e.g. by a form action), sync the visual picker
        hiddenInput.on("change", function () {
            const newValue = $(this).val()?.toString() ?? "";
            const parsed = moment(newValue);
            const yearContainer = $(element);
            if (newValue === "" || !parsed.isValid()) {
                (yearContainer as any).data('DateTimePicker').date(null);
            } else {
                const currentPickerDate = (yearContainer as any).data('DateTimePicker').date();
                if (!currentPickerDate || currentPickerDate.year() !== parsed.year()) {
                    (yearContainer as any).data('DateTimePicker').date(moment(new Date(parsed.year(), 0, 1)));
                }
            }
        });
    });

    // Init TimePicker
    $(filter).find(".clockpicker:has(> input:not([readonly]))").clockpicker(); // Selects clockpickers that do not have input element with readonly attribute.

    luscinia.initNumberSliders(filter);

    luscinia.initCheckboxSwitches(filter);

    //WARNING THIS CODE IS VERY SENSITIVE TO CHANGES
    $(filter).find(".inputmask").each(function (index, inputMask) {
        let options: Inputmask.Options = {
            autoUnmask: true,
            removeMaskOnSubmit: true,
            onKeyDown(event, buffer, caretPos, opts) {
            },
            onUnMask: function (maskedValue: string, unmaskedValue: any) {
                if (this.opts.radixPoint === ',') {
                    maskedValue = maskedValue.replace(".", "");
                    maskedValue = maskedValue.replace(",", ".");
                }
                if (this.opts.radixPoint === '.') {
                    maskedValue = maskedValue.replace(",", "");
                }
                let floatValue = parseFloat(maskedValue);
                if (isNaN(floatValue)) {
                    return "0";
                }
                if (inputMask.classList.contains("percentage")) {
                    maskedValue = (floatValue / 100).toFixed(this.opts.digits + 2);
                }
                else
                {
                    maskedValue = floatValue.toFixed(this.opts.digits);
                }
                return maskedValue;
            },
            onBeforeMask: function (initialValue: any, opts: any) {
                let floatValue = parseFloat(initialValue);
                if (isNaN(floatValue)) {
                    return "0";
                }
                if (inputMask.classList.contains("percentage")) {
                    floatValue = floatValue * 100;
                }
                initialValue = floatValue.toFixed(this.opts.digits);
                if (opts.radixPoint === ',') {
                    initialValue = initialValue.replace(".", ",");
                }
                return initialValue;
            }
        };
    
        let im = new Inputmask(options);
        im.mask(inputMask);
    });

    // Init SignaturePad
    $(filter)
        .find('.bsignature')
        .each(function () {
            const signaturePad = new SignaturePad($(this)[0] as HTMLCanvasElement);
            $(this).data('signaturePad', signaturePad);
            const relatedInputName = $(this).data('luscinia-relatedinput');
            const relatedInputs = $(filter).find(`input[name="${relatedInputName}-signature"]`);
            const dataUrl = relatedInputs.first().val().toString();
            if (dataUrl !== '') {
                signaturePad.fromDataURL(dataUrl);
            }

            const isDisabled = $(this).attr('disable-signature-pad') === 'true';
            if (isDisabled) {
                signaturePad.off();
                $(this).css('background-color', '#eee');
            }

            if (!isDisabled) {
                // Clear the signaturePad Button
                $(filter)
                    .find('.signatureclear')
                    .on('click', function () {
                        const relatedCanvas = $(this).parent().prev().children('.bsignature');
                        const signaturePad = relatedCanvas.data('signaturePad');
                        if (signaturePad) {
                            signaturePad.clear();
                        }
                    });
            } else {
                $(filter)
                    .find('.signatureclear')
                    .remove();
            }
        });


    // Init ajax select
    $(filter).find("." + luscinia.css.ajaxSelect).each(function () {
        initFormElementPromiseList.push(luscinia.initializeAjaxSelect2($(this)));
    });

    // Init inline select
    $(filter).find("." + luscinia.css.inlineSelect).each(function () {
        luscinia.initializeInlineSelect2($(this));
    });

    // Init address select
    $(filter).find('.placecomplete').each(function () {
        ($(this) as any).placecomplete({
            width: "100%",
            placeholderText: $(this).data(luscinia.data.placeHolder),
            requestParams: {
                types: ["address"]
            }
        });
        $(this).on({
            "placecomplete:selected": function (evt, placeResult) {
                $(this).attr("value", placeResult.display_text);
            }
        });
    });

    await luscinia.initMultiSelect2(filter);
    $(filter).find(".luscinia-multi-select-input").each((i, el) => {
        new MultiSelectInput(el as HTMLTableElement).render();
    })

    saveFormState(form);

    return Promise.all(initFormElementPromiseList).then(function () {
        luscinia.bindPostValueChanged(form, filter);
    }).catch(function (e) {
        //If one of the promises fails still bind postvaluechange
        luscinia.bindPostValueChanged(form, filter);
    });
};

function getDateTimeLocalizedValue(value: string): Date {
    const localizedTime = moment(value).local().format('YYYY-MM-DDTHH:mm:ss');
    return new Date(localizedTime);
}

function saveFormState(form: JQuery<HTMLFormElement>) {
    const formData = luscinia.serializeFormObject(form);
    let formObject: object = getFormObject(formData);
    localStorage.setItem(`formData-${form.attr("id")}`, JSON.stringify(formObject));
}